export type ClampingOption = {
  value: string;
  labelKey: string;
};

export const clampingTypes: ClampingOption[] = [
  { labelKey: 'traceability.clampingTab.options.vise', value: 'etaux' },
  { labelKey: 'traceability.clampingTab.options.clamp', value: 'bride' },
  { labelKey: 'traceability.clampingTab.options.fixture', value: 'posage' },
  { labelKey: 'traceability.clampingTab.options.chuck', value: 'mandrin' },
  { labelKey: 'traceability.clampingTab.options.rotarySteady', value: 'canon_tournant' },
  { labelKey: 'traceability.clampingTab.options.fixedSteady', value: 'canon_fixe' },
  { labelKey: 'traceability.clampingTab.options.collet', value: 'pince' },
  { labelKey: 'traceability.clampingTab.options.vacuum', value: 'vacuum' },
  { labelKey: 'traceability.clampingTab.options.glue', value: 'colle' },
  { labelKey: 'traceability.clampingTab.options.gel', value: 'gel' },
  { labelKey: 'traceability.clampingTab.options.other', value: 'autre' },
];
